// src/components/ui/badge.jsx

import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-text-on-primary shadow",
        secondary:
          "border-transparent bg-secondary text-text",
        destructive:
          "border-transparent bg-danger text-white",
        success:
          "border-transparent bg-success text-white",
        warning:
          "border-transparent bg-warning text-text",
        outline:
          "border-neutral-dark/30 text-text bg-transparent",
        ghost:
          "border-transparent bg-neutral-light text-text",
        // Custom status variants
        active:
          "border-transparent bg-success-light text-success-dark",
        inactive:
          "border-transparent bg-neutral-light text-neutral-dark",
        pending:
          "border-transparent bg-warning-light text-warning-dark",
        error:
          "border-transparent bg-danger-light text-danger-dark",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({ className, variant, ...props }) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
